import React, { useState, useEffect } from 'react';
import herobg from '../../assets/about/herobg.png';

const HeroSection = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <section
            className="relative w-full h-screen flex items-center justify-center overflow-hidden"
            role="banner"
            aria-label="RoadExpress logistics services hero section"
        >
            {/* Background Video */}
            <video
                className="absolute inset-0 w-full h-full object-cover scale-105"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                onError={(e) => {
                    console.error('Video failed to load:', e);
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'block';
                }}
            >
                <source src="https://prod-roadexpress.s3.ap-south-1.amazonaws.com/website/companypage.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* Background overlay for better text readability */}
            <div className="absolute inset-0 bg-black/40 z-10" aria-hidden="true"></div>

            {/* Main Content */}
            <div className="relative z-20 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    {/* Main Heading */}
                    <div
                        className={`transform transition-all duration-1000 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                            }`}
                        style={{ transitionDelay: '0.2s' }}
                    >
                        <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-6 text-white">
                            Your Trusted
                            <span className="text-[#F05A28]"> Logistics Partner</span>
                            <br />
                            Across India
                        </h1>
                    </div>

                    {/* Description */}
                    <div
                        className={`transform transition-all duration-1000 ease-out ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
                            }`}
                        style={{ transitionDelay: '0.4s' }}
                    >
                        <p className="text-lg md:text-xl lg:text-xl text-white/90 max-w-5xl mx-auto leading-relaxed mb-8">
                            RoadExpress is a trustworthy modern-day logistics platform integrated with advanced technology that
                            strives to provide unique and efficient solutions for your varied logistical needs across India.
                        </p>
                    </div>
                </div>
            </div>

            {/* Schema.org structured data for SEO */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "RoadExpress",
                        "description": "Trustworthy modern-day logistics platform integrated with advanced technology providing efficient solutions for varied logistical needs across India",
                        "areaServed": "India",
                        "serviceType": "Logistics Services"
                    })
                }}
            />
        </section>
    );
};

export default HeroSection;